export default "__VITE_ASSET__8rXwBj8c__"